import { TFunction } from 'react-i18next';
import {
  CategoriesTabContainer,
  FiltersTabContainer,
  PopularCategoriesTabContainer,
  CategoryDetailsTabContainer,
  CategoryFiltersTabContainer,
  CategoriesSEOContainer,
} from '../containers';
import { CategoryLocaleCodes } from '@/models/categories.model';

export enum CategoriesTabs {
  CATEGORIES = 'categories',
  FILTERS = 'filters',
  POPULAR_CATEGORIES = 'popular_categories',
}

export enum CategoryDetailsTabs {
  CATEGORIES = 'categories',
  SEO = 'seo',
  FILTERS = 'filters',
}

export enum CategoryNameTabs {
  UK = 'UA',
  RU = 'RU',
}

export const getCategoriesTabsConfig = (t: TFunction) => [
  {
    label: t('categories_tab_title'),
    key: CategoriesTabs.CATEGORIES,
    content: <CategoriesTabContainer />,
  },
  {
    label: t('filters_tab_title'),
    key: CategoriesTabs.FILTERS,
    content: <FiltersTabContainer />,
  },
  {
    label: t('popular_categories_tab_title'),
    key: CategoriesTabs.POPULAR_CATEGORIES,
    content: <PopularCategoriesTabContainer />,
  },
];

export const getCategoryDetailsTabsConfig = (t: TFunction) => [
  {
    label: t('category_details_tab_title'),
    key: CategoryDetailsTabs.CATEGORIES,
    content: <CategoryDetailsTabContainer />,
  },
  {
    label: t('category_seo_tab_title'),
    key: CategoryDetailsTabs.SEO,
    content: <CategoriesSEOContainer />,
  },
  {
    label: t('category_filters_tab_title'),
    key: CategoryDetailsTabs.FILTERS,
    content: <CategoryFiltersTabContainer />,
  },
];

export const getCategoryNameTabsConfig = () => {
  return [
    {
      label: 'UA',
      key: CategoryLocaleCodes.UK,
    },
    {
      label: 'RU',
      key: CategoryLocaleCodes.RU,
    },
  ];
};
